export default {
    SET_TYPE_OF_CONTRACTS(state, payload) {
        state.type_of_contracts = payload;
    },
}